export const restrict = (e, number, set) => {
  const value = e.target.value;
  if (value.length <= number) set(value);
};
